export default __webpack_public_path__ + "static/media/Beachy-Turquoise-Dangling-Earrings.f20589bc.jpg";